import React from 'react';
import { format } from 'date-fns';
import { DatePickerModal } from './DatePickerModal';
import { DatePickerPopup } from './DatePickerPopup';
import './TopBarDatePicker.scss';
const chevron = require('./chevron.svg');

interface TopBarDatePickerProps {
  start: Date;
  end: Date;
  onSubmit(start: Date, end: Date);
}

interface TopBarDatePickerState {
  menuOpen: boolean;
  isBelowBreakingpoint: boolean;
}

export class TopBarDatePicker extends React.Component<TopBarDatePickerProps, TopBarDatePickerState> {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      isBelowBreakingpoint: true,
    };
  }

  componentDidMount() {
    if (process.env.BUILD_TARGET == 'client') {
      this.setState({
        isBelowBreakingpoint: window.innerWidth < 768,
      });
    }
  }

  toggleMenu = () => {
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  };

  handleSubmit = (start, end) => {
    this.setState(
      {
        menuOpen: false,
      },
      () => {
        this.props.onSubmit(start, end);
      }
    );
  };

  render() {
    const dateFormat = 'LLL. d, yyyy';

    const selected = {
      start: this.props.start,
      end: this.props.end,
    };

    let menuContent = null;
    if (this.state.menuOpen) {
      menuContent = <DatePickerPopup selected={selected} update={this.handleSubmit} toggle={this.toggleMenu} />;
    }

    return (
      <div className='dashboard-date-picker-container'>
        <div className='text-md-right dashboard-date-picker-wrapper'>
          <div className='d-md-none dashboard-date-picker-label'>Current Period</div>
          <p className='dashboard-date-picker' onClick={this.toggleMenu}>
            {format(this.props.start, dateFormat)}&nbsp;-&nbsp;
            {format(this.props.end, dateFormat)}
            <img src={chevron} className='img-fluid dashboard-date-picker-icon d-none d-md-inline-block' />
          </p>
          {menuContent}
        </div>
        {this.state.isBelowBreakingpoint && (
          <DatePickerModal
            isOpen={this.state.menuOpen}
            toggle={this.toggleMenu}
            selected={selected}
            update={this.handleSubmit}
          />
        )}
      </div>
    );
  }
}
